;
(function() {
    var eventHub = {};
    eventHub.install = function(Vue) {
        var eventHub = new Vue();
        Object.defineProperties(eventHub, {
            on: {
                get: function() {
                    return eventHub.$on
                }
            },
            emit: {
                get: function() {
                    return eventHub.$emit
                }
            },
            off: {
                get: function() {
                    return eventHub.$off
                }
            }
        });
        Object.defineProperty(Vue.prototype, '$eventHub', {
            get: function() {
                return eventHub;
            }
        });

        Object.defineProperty(Vue, 'eventHub', {
            get: function() {
                return eventHub;
            }
        });
    }

    //支持 common js
    if (typeof exports == "object") {
        module.exports = eventHub;
    } else if (typeof define == "function" && define.amd) {
        define([], function() {
            return eventHub;
        })
    } else if (window.Vue) {
        window.EventHub = eventHub;
        Vue.use(EventHub);
    }

})();


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-event-hub/index.js
// module id = 1199
// module chunks = 0